import { ApiInfo } from "../api/api-info";
import { ApiInfoResource } from "../api/api-info-resource";
import { ApiRoutesDictionary } from "../api/api-routes-dictionary";
import Link from "../link";

export class ApiResourceMapper {
    static map(resource: ApiInfoResource): ApiInfo {
        const apiRoutes = new ApiRoutesDictionary();

        for (const [key, value] of Object.entries<Link>(resource.routes)) {
            apiRoutes[key] = value;
        }

        const apiInfo = new ApiInfo(resource.fileVersion, resource.minimumSdkVersion, apiRoutes);

        return apiInfo;
    }
}
